import React, { useState, useEffect, useRef, } from 'react'
import ReCAPTCHA from 'react-google-recaptcha';
import parse from 'html-react-parser';
//import { useNavigate } from 'react-router-dom';


import useAuth from '../../auth/UseAuth';

import {
    getResponse, settings, isValidEmail, styles, handleResponseMessageAsync, isUndNullEmp, getLanguageObj, notificationsToastGetAsync,
    notificationsToastShowAsync, LoadingSection
} from '../../helpers/main';
import { RequestAccountService } from '../../services/auth/RequestAccountService';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { Toast, } from '../../classess/notifications/toast.js'
import { NotificationToast, } from '../../classess/main/notifications/notificationToast.js'
import { RequestAccountMonitorReq, RequestAccountRes } from '../../classess/account/requestAccount';

// const $ = window.jqGlobal || window.jQuery;

const { icons, images, labels, messages, } = settings;

const currentMethod = 'RequestAccountMonitor';

export default function RequestAccountMonitor({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    //const navigate = useNavigate();

    const [dataForm, setDataForm] = useState(RequestAccountMonitorReq.class({}, false));
    const [dataFormLength] = useState(RequestAccountMonitorReq.minMaxLength(false));
    const [errors, setErrors] = useState({ userEmail: '', companyEmail: '' });

    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: true, save: false });

    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-light border w-100 px-4 shadow-sm font-weight-bold text-secondary',
                id: 'btnBack',
            },
            home: {
                defaultClass: 'btn btn-light border w-100 px-4 shadow-sm font-weight-bold text-secondary',
                id: 'btnHome',
            },
            request: {
                defaultClass: 'btn btn-primary w-100 px-4 shadow-sm font-weight-bold',
                id: 'btnRequest',
            },
        },
        icons: {
            request: {
                id: 'iconRequest',
                defaultClass: icons?.fasFa?.search,
            },
        },
        inputs: {
            email: {
                id: 'inputEmail',
            },
            userName: {
                id: 'inputUserName',
            },
        },
        spiners: {
            request: {
                id: 'spRequest',
                defaultClass: '',
            }
        },
    };

    const reCaptchaRef = useRef(ReCAPTCHA);
    //#endregion variables

    //#region methods
    const setErrorDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorDefault';
        try {
            setErrors(prev => ({ ...prev, userEmail: '', companyEmail: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            if (isUndNullEmp({ data: dataForm, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    userEmail: messages?.thisFieldRequired?.[languageObj?.id],
                    companyEmail: messages?.thisFieldRequired?.[languageObj?.id]
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.userName, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    userEmail: messages?.thisFieldRequired?.[languageObj?.id]
                }));
                response.isWarning = true;
            } else if (!isValidEmail({ data: dataForm?.userName })) {
                setErrors(prev => ({
                    ...prev,
                    userEmail: messages?.youMustEnterValidEmail[languageObj?.id]
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm?.email, subMethod: currentMethod })?.result) {
                setErrors(prev => ({
                    ...prev,
                    companyEmail: messages?.thisFieldRequired?.[languageObj?.id]
                }));
                response.isWarning = true;
            } else if (!isValidEmail({ data: dataForm?.email })) {
                setErrors(prev => ({
                    ...prev,
                    companyEmail: messages?.youMustEnterValidEmail[languageObj?.id]
                }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const requestAccountMonitor = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'requestAccountMonitor';
        try {
            if (e) e?.preventDefault?.();

            //#region variables
            let requestAccount = RequestAccountRes.class({}, false);
            //#endregion variables

            //#region error default
            response = setErrorDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion error default

            //#region form data validate
            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion form data validate

            setProcess(prev => ({ ...prev, save: true }));

            //#region recaptcha (get)
            const reCaptchaToken = await reCaptchaRef?.current?.executeAsync();
            reCaptchaRef?.current?.reset();
            //#endregion recaptcha (get)

            //#region request account (get)
            response = await RequestAccountService.getByUserNameAndEmailAsync({
                userName: dataForm?.userName,
                email: dataForm?.email,
                reCaptchaToken: reCaptchaToken,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            requestAccount = RequestAccountRes.class(
                response?.result?.requestAccount,
                false,
            );
            //#endregion request account (get)

            //#region request account (set)
            if (!isUndNullEmp({ data: requestAccount, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: requestAccount?.id, subMethod: currentMethod })?.result &&
                requestAccount?.id > 0) {
                window.location.href = `${settings?.backend?.urls?.requestAccountDetails}/${requestAccount.id}/false`;
            } else {
                response = getResponse({ type: 1 });
                response.msgText = `${messages?.thereIsNoDataToProcess?.[languageObj?.id]}`;
                return;
            }
            //#endregion request account (set)

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, save: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess
                });
            }
        }
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region variables
            let notificationToastsData = [Toast?.getClass({}, false)];
            let notificationsToastObj = {
                ...NotificationToast?.getClass({}, false),
                controller: settings?.app?.views?.accounts?.accounts,
                method: settings?.app?.views?.accounts?.requestAccountMonitor,
                isAuthenticated: false,
            };
            //#endregion variables

            //#region notificationtoast (get)
            response = await notificationsToastGetAsync({
                data: notificationsToastObj,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            notificationToastsData = response?.result?.toasts || []
            //#endregion notificationtoast (get)

            //#region set data form
            setDataForm(RequestAccountMonitorReq.class({}, false));
            //#endregion set data form

            //#region show toasts
            response = await notificationsToastShowAsync({
                data: notificationToastsData,
                languageId: languageObj?.id,
                window: window,
                document: document,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion show toasts

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess
                });
            }
        }
    }

    useEffect(() => {
        getData({ subMethod: 'RequestAccountMonitor - onLoad' });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={settings?.app?.views?.main?.home} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.requestAccountMonitor?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.requestAccountMonitor?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {showData ? (
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='login-box' style={styles?.loginBox}>

                                        <div className='card border-0 shadow-lg bg-white rounded-lg'>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            {/*Header*/}
                                            <div className='card-header border-bottom-0 pt-4 pb-0 bg-white'>
                                                <h5 className='font-weight-bold mx-2'><img src={images?.icons?.user} alt='UserLogin' style={styles?.cardHeaderLogo} className='mr-2' />{labels?.monitorRequest?.[languageObj?.id]}</h5>
                                            </div>

                                            <form onSubmit={(e) => requestAccountMonitor({
                                                e: e,
                                                subMethod: 'requestAccountMonitorForm'
                                            })} method='post'>

                                                {/*Body*/}
                                                <div className='card-body px-4'>
                                                    <div className='form-group mb-4'>
                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                            <i className={`${icons?.fasFa?.envelope} mr-1`} /> {labels?.userEmail?.[languageObj?.id]}
                                                        </small>
                                                        <input autoFocus
                                                            className='form-control form-control-lg bg-light border-0 shadow-sm'
                                                            style={{ borderRadius: '5px' }}
                                                            id={controls?.inputs?.userName.id}
                                                            maxLength={dataFormLength?.max?.userName}
                                                            onChange={(e) => setDataForm({ ...dataForm, userName: e?.target?.value })}
                                                            onFocus={() => setErrors(prev => ({ ...prev, userEmail: '' }))}
                                                            readOnly={process?.save}
                                                            value={!isUndNullEmp({ data: dataForm, subMethod: 'userEmailInput' })?.result ? dataForm.userName : ''}
                                                            placeholder={labels?.userEmail?.[languageObj?.id]}
                                                            title={labels?.userEmail?.[languageObj?.id]} />
                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userEmail)}</div>
                                                    </div>

                                                    <div className='form-group mb-4'>
                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                            <i className={`${icons?.fasFa?.envelope} mr-1`} /> {labels?.companyEmail?.[languageObj?.id]}
                                                        </small>
                                                        <input className='form-control form-control-lg bg-light border-0 shadow-sm'
                                                            style={{ borderRadius: '5px' }}
                                                            id={controls?.inputs?.email?.id}
                                                            maxLength={dataFormLength?.max?.email}
                                                            onChange={(e) => setDataForm({ ...dataForm, email: e?.target?.value, })}
                                                            onFocus={() => setErrors(prev => ({ ...prev, companyEmail: '' }))}
                                                            readOnly={process?.save}
                                                            value={!isUndNullEmp({ data: dataForm, subMethod: 'companyEmailInput' })?.result ? dataForm.email : ''}
                                                            placeholder={labels?.companyEmail?.[languageObj?.id]}
                                                            title={labels?.companyEmail?.[languageObj?.id]} />
                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.companyEmail)}</div>
                                                    </div>
                                                </div>

                                                {/*Footer*/}
                                                <div className='card-footer py-4 bg-white border-top-0 rounded-lg'>
                                                    <div className='row justify-content-center w-100 mx-0'>
                                                        <div className='col-12 col-sm-auto px-1 mb-2 mb-sm-0'>
                                                            <button id={controls?.buttons?.request.id}
                                                                title={labels?.request?.[languageObj?.id]}
                                                                data-toggle='tooltip'
                                                                type='submit'
                                                                disabled={process?.save}
                                                                style={{ borderRadius: '5px' }}
                                                                className={`${controls?.buttons?.request?.defaultClass} ${process?.save ? settings?.react?.settings?.react?.html?.button?.classes?.disabled : ''}`}>
                                                                {!process?.save ? (
                                                                    <i id={controls?.icons?.request?.id} className={`${icons?.fasFa?.search}`} />
                                                                ) : (
                                                                    <span id={controls?.spiners?.request.id} className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                                )} {labels?.search[languageObj?.id]}
                                                            </button>
                                                        </div>
                                                        <div className='col-12 col-sm-auto px-1 mb-2 mb-sm-0'>
                                                            <a id={controls?.buttons?.back?.id}
                                                                href={process?.save ? '/#' : settings?.backend?.urls?.login}
                                                                title={labels?.back?.[languageObj?.id]}
                                                                style={{ borderRadius: '5px' }}
                                                                className={`${controls?.buttons?.back?.defaultClass} ${process?.save ? settings?.react?.settings?.react?.html?.button?.classes?.disabled : ''}`}>
                                                                <i className={`${icons?.fasFa?.arrowAltCircleLeft}`} /> {labels?.back?.[languageObj?.id]}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>

                                            </form>

                                            <div>
                                                <ReCAPTCHA className='g-recaptcha'
                                                    hl={languageObj?.id}
                                                    ref={reCaptchaRef}
                                                    sitekey={settings?.react?.reCAPTCHA?.reCAPTCHASiteKey}
                                                    size='invisible' />
                                            </div>
                                        </div>

                                    </div>

                                    <div className='text-muted text-center text-small'>
                                        <p>
                                            <small>
                                                {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a target='_blank'
                                                    href={settings?.react?.reCAPTCHA?.urlPrivaciConditions}
                                                    rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                                </a>
                                            </small>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}

                    </div>
                </section>

            </div>
        </div>
    )
}